import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from '../environments/environment';
import { ApiAboutService } from './Services/api-about.service';
export const defaultSupportEmail = "support" + "@" + "voatzsupport.zendesk" + "." + "com";
import '@angular/localize/init';
import { SessionService } from './Services/session.service';
import { Router } from '@angular/router';
import { dashboardRoute } from './route-names';
import { ElectorDataService } from './Services/elector-data.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: { preventDefault: () => void; returnValue: boolean; }) {
    event.preventDefault();
    event.returnValue = true;
  }
  @HostListener('window:pagehide', ['$event'])
  async pageHideHandler(event: any) {
    if(this.sessionService.activeSessionHere()) {
      this.sessionService.killSession();
    }
  }
  title = 'voter-web-portal';
  clientFAQ: string;
  isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  supportEmail = defaultSupportEmail;
  accessibiltyAriaLabel = $localize`Focus starts here for consistent navigation`
  
  constructor(private breakpointObserver: BreakpointObserver,
    public electorDataService: ElectorDataService,
    private readonly router: Router,
    public apiAbout: ApiAboutService,
    readonly sessionService: SessionService) {
    this.clientFAQ = environment.clientWebURL;
  }

  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    const spinner = document.getElementById('initial-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }
  }

  onActivate(): void {
    window.scrollTo(0, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  }

  ngOnDestroy(): void {
    if (this.sessionService.dialogRef) {
      this.sessionService.dialogRef.close();
      this.sessionService.dialogRef = undefined;
    }
  }

  gotoDashboard() {
    this.router.navigate(dashboardRoute);
  }

}
